import { Dispatch, SetStateAction, useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { CustomizedTabs, ITab } from 'components/common/CustomizedTabs/CustomizedTabs';

import classes from './TabsSection.module.scss';

export type IActiveTab = 'cardDetails' | 'activityDetails' | 'activityRelationships' | 'relatedCards' | 'auditLogs';

interface Props<T> {
    tabs: ITab<T>[];
    activeTab: T;
    setActiveTab: Dispatch<SetStateAction<T>>;
    wrapperClass?: string;
}

export const TabsSection = <T extends string>({ tabs, activeTab, setActiveTab, wrapperClass }: Props<T>) => {
    const history = useHistory();
    const { search, state } = useLocation();

    useEffect(() => {
        history.replace({
            hash: activeTab,
            search,
            state,
        });
    }, [activeTab]);

    return (
        <div className={classes.tabsSectionContainer}>
            <CustomizedTabs<T>
                tabs={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                wrapperClass={wrapperClass}
            />
        </div>
    );
};
